import { shuffleArray } from './_shuffleArray';

export function logo() {
  // 文字列を配列に変換し、不正な入力があるかどうかチェックする関数
  function parseArrayString(arrayString) {
    let parsedArray;
    try {
      parsedArray = JSON.parse(arrayString);
    } catch (e) {
      console.error("Invalid JSON format");
      return null;
    }

    if (!Array.isArray(parsedArray)) {
      console.log("Input is not an array");
      return null;
    }

    for (let i = 0; i < parsedArray.length; i++) {
      const item = parsedArray[i];
      if (!Array.isArray(item) || item.length !== 3) {
        console.log("Invalid array item format");
        return null;
      }

      const shapeIndex = parseInt(item[0]);
      if (isNaN(shapeIndex) || shapeIndex < 0 || shapeIndex >= shapes.length) {
        console.log("Invalid shape index");
        return null;
      }

      const color = item[1];
      if (!/^#[0-9A-Fa-f]{6}$/.test(color)) {
        console.log("Invalid color value");
        return null;
      }
    }

    return parsedArray;
  }
  // 図形アップデート関数
  function createLogo(target, layerDataArray) {
    if(layerDataArray){
      target.innerHTML = '';
      layerDataArray.forEach((layerData, index) => {
        const shapeIndex = layerData[0];
        const color = layerData[1];
        const blur = layerData[2];
        let svg = shapes[shapeIndex];
        if (color !== "") {
          svg = svg.replace(/<g[^>]*>/g, (match) =>
            match.replace(">", ` fill="${color}">`)
          );
        }
        // If a blur value exists, apply it
        if (blur !== "") {
          svg = svg.replace(/<g[^>]*>/g, (match) =>
            match.replace(">", ` filter="url(#blur${blur})">`)
          );
        }
        target.innerHTML += svg;
        target.innerHTML += `<defs>
          <filter id="blur1">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
          </filter>
          <filter id="blur2">
            <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
          </filter>
          <filter id="blur3">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" />
          </filter>
        </defs>`
      });
      const g = target.querySelectorAll('g');
      if(g.length) {
        g.forEach((gg, index) => {
          setTimeout(() => {
            gg.classList.add('is-active')
          }, 200*(index+1));
        })
      }
    }
  }
  const logos = document.querySelectorAll('[data-logo-layers]');
  if(logos.length){
    const footerColorArr = []
    logos.forEach((logo, index) => {
      const layers = logo.dataset.logoLayers
      const array = parseArrayString(layers);
      createLogo(logo,array);
      // array.forEach((arr,i) => {
      //   footerColorArr.push(arr[1])
      // })
    });
    // if(footerColorArr.length > 1) {
    //   const ar = shuffleArray(footerColorArr)
    //   const style = document.createElement('style');
    //   document.head.appendChild(style);
    //   style.sheet.insertRule(`:root{--footer-bgcolor: ${ar[0]};--footer-primarycolor: ${ar[1]};}`);
    // }
  }

}